const playlistsList = {
  "playlists.list.empty": "¡No hay listas de reproducción que mostrar!",
  "playlists.list.save.error": "Se produjo un error al guardar la lista de reproducción",
};

const playlistModal = {
  "playlists.playlist.finished.modal.title.improved": "¡Felicidades!",
  "playlists.playlist.finished.modal.title.completed": "¡Felicidades!",
  "playlists.playlist.finished.modal.title.failed": "¡Mejor suerte la próxima vez!",
  "playlists.playlist.finished.modal.body.improved": "Completaste la lista de reproducción y ganaste una nueva recompensa.",
  "playlists.playlist.finished.modal.body.completed": "Completaste la lista de reproducción y obtuviste {{ reward }}.",
  "playlists.playlist.finished.modal.body.failed": "No completaste la lista de reproducción esta vez.",
  "playlists.playlist.finished.modal.targets.title": "Alcanza los siguientes objetivos para obtener una mejor recompensa:",
  "playlists.playlist.finished.modal.targets.your-score": "Tu puntuación:",
  "playlists.playlist.finished.modal.targets.next-target": "Objetivo para la próxima recompensa:",
};

const playlistSection = {
  "playlists.section.view": "Ver",
  "playlists.section.join.short": "Unirse",
  "playlists.section.join.full": "Unirse a la Lista de Reproducción",
};

const playlistStatus = {
  'playlists.playlist.status.label': 'Estado',
  'playlists.playlist.status.null': 'No Iniciado',
  'playlists.playlist.status.not_started': 'No Iniciado',
  'playlists.playlist.status.completed': 'Completado',
  'playlists.playlist.status.failed': 'Fallido',
  'playlists.playlist.status.winner': 'Ganador',
};

const playlistsPage = {
  "playlists.page.title": "Listas de Reproducción",
  "playlists.subheader.continue": "Continuar",
  "playlists.subheader.categories": "Explorar por Categoría",
  "playlists.subheader.drills": "Listas de Reproducción de Entrenamiento",
  "playlists.subheader.recently.played": "Jugados Recientemente",
  "playlists.view.playlist": "Ver Lista de Reproducción",
  "playlists.subheader.featured": "Listas de Reproducción Destacadas",
  "playlists.promo.caption": "Lista de Reproducción del Mes",
  "playlists.latest.caption": "Última Lista de Reproducción",
  "playlists.fallback.career.caption": "¡Continúa la Carrera para avanzar a nuevas ligas y desbloquear Listas de Reproducción!",
  "playlists.categories.all": "Todos",
};

const playlistPage = {
  "playlist.scenarios.amount": "{{ count }} escenarios",
  "playlists.playlist.page.title": "Lista de Reproducción",
  "playlists.playlist.list.header": "Listas de Reproducción ({{ playlists }})",
  "playlists.playlist.page.join": "Unirse",
  "playlists.playlist.page.details": "Detalles",
  "playlists.playlist.page.scenarios": " escenarios",
  "playlists.playlist.page.has-ended": "Esta lista de reproducción ha terminado",
  "playlists.playlist.page.ends-in": "Termina en {{ time }}",
  "playlists.playlist.page.not-started": "Esta Lista de Reproducción no ha comenzado aún",
  "playlists.playlist.page.current.score": "Tu puntuación actual",
  "playlists.playlist.page.current.score.main.metric": "BYB IQ:",
  "playlists.playlist.page.rewards": "Recompensas",
  "playlists.playlist.page.leaderboard.title": "Clasificación",
  "playlists.playlist.page.leaderboard.top": "Clasificación (Top {{ count }})",
  "playlists.playlist.page.leaderboard.join": "Unirse",
  "playlists.playlist.page.leaderboard.see-all": "Ver todos",
  "playlists.playlist.page.leaderboard.no-data": "Ningún jugador ha completado esta lista de reproducción aún",
  "playlists.playlist.page.description": "Descripción",
  "playlists.playlist.page.results.title": "Tus resultados",
  "playlists.playlist.page.results.see-all": "Ver todos los resultados",
  "playlists.playlist.page.create": "Crear",
  "playlists.playlist.page.update": "Actualizar",
  "playlists.playlist.page.no-scenarios": "No hay escenarios añadidos",
};

const playlistCategoryPage = {
  "playlists.category.page.latest.playlist": "Última Lista de Reproducción",
  "playlists.category.page.grid.title": "{{ count }} Listas de Reproducción",
};

const playlistReward = {
  "playlist.results.header": "Resultados",
  "playlist.best.result": "Mejor Resultado",
  "playlist.results.see-all": "Ver todos los resultados",
  "playlist.performance.header": "Último Rendimiento",
  "playlist.best.result.no.data": "No hay datos disponibles",
  "playlist.sessions.no-data": "No hay sesiones disponibles",
  "playlists.reward.target": "Objetivo: {{ target }} {{ metric }}",
  "playlists.reward.place": "{{ place }} lugar",
  "playlists.reward.not.ranked": "No clasificado",
  "playlists.reward.achieved.on": "Obtenido el {{ date }}",
  "playlists.reward.not.achieved": "Aún no obtenido",
  "playlists.reward.scarcity": "Obtenida por el {{ scarcity }}% de los jugadores que intentaron esta lista de reproducción",
  "playlists.reward.best.iq": "{{ iq }} BYB IQ",
  "playlists.reward.no.date.available": "No disponible",
};

const playlistCard = {
  "playlists.card.locked.tooltip": "Avanza en tu Carrera para desbloquear esta Lista de Reproducción",
  "playlists.card.starts-in": "Comienza en {{ time }}",
  "playlists.card.ends-in": "Termina en {{ time }}",
  "playlists.card.has-ended": "Terminado",
  "playlists.play-playlist": "Jugar Lista de Reproducción",
};

const playlistFilter = {
  "playlists.filter.title": "Filtrar",
  "playlists.filter.not_started": "No Iniciado",
  "playlists.filter.completed": "Completado",
  "playlists.filter.failed": "Fallido",
  "playlists.filter.locked": "Bloqueado",
  "playlists.filter.clear": "Limpiar todo",
  "playlists.filter.apply": "Aplicar filtros ({{ count }})",
};

const playlistSharingDialog = {
  "playlists.playlist.sharing.users": "Usuarios",
  "playlists.playlist.sharing.teams": "Equipos",
  "playlists.playlist.sharing.accounts": "Cuentas",
  "playlists.playlist.sharing.filter-selected": "Filtrar seleccionados",
  "playlists.playlist.sharing.previous": "Anterior",
  "playlists.playlist.sharing.next": "Siguiente",
  "playlists.playlist.sharing.page": "Página {{ page }} de {{ total }}",
  "playlists.playlist.sharing.share.title": "Compartir Lista de Reproducción",
  "playlists.playlist.sharing.user.name": "Usuario {{ name }}",
  "playlists.playlist.sharing.user.unknown": "Usuario Desconocido",
  "playlists.playlist.sharing.no.name": "Sin Nombre",
  "playlists.playlist.sharing.unknown": "Desconocido",
  "playlists.playlist.sharing.group.name": "Grupo: {{ name }}",
  "playlists.playlist.sharing.no.group": "Sin Grupo",
  "playlists.playlist.sharing.members": "Miembros: {{ count }}",
};

const playlistScenarioSelectionDialog = {
  "playlists.playlist.selection.your.account": "Tu Cuenta",
  "playlists.playlist.selection.no.scenarios": "No se encontraron escenarios",
};

const playlistListItem = {
  "playlists.playlist.list.item.status.published": "Publicado",
  "playlists.playlist.list.item.status.draft": "Borrador",
  "playlists.playlist.list.item.delete-confirmation.title": "¿Estás seguro de que quieres eliminar la lista de reproducción {{ name }}?",
};

const playlistScenarioSelector = {
  "playlists.playlist.scenario.selector.tooltip": "Selecciona escenarios para incluir en la lista de reproducción",
};

const playlistScenarioSettings = {
  "playlists.playlist.scenario.settings.title": "Configuración del Juego",
  "playlists.playlist.scenario.settings.game-speed": "Velocidad del Juego",
  "playlists.playlist.scenario.settings.bullet-time": "Tiempo Bala",
  "playlists.playlist.scenario.settings.mirrored": "Espejo",
  "playlists.playlist.scenario.settings.awareness.title": "Configuración de Memoria",
  "playlists.playlist.scenario.settings.awareness.player-count": "Número de Jugadores",
  "playlists.playlist.scenario.settings.awareness.time-limit": "Límite de Tiempo",
  "playlists.playlist.scenario.settings.awareness.distance": "Distancia",
};

const customPlaylists = {
  "playlists.custom.name": "Nombre",
  "playlists.custom.start": "Inicio",
  "playlists.custom.end": "Fin",
  "playlists.custom.scenarios": "Escenarios",
  "playlists.custom.published": "Publicado",
  "playlists.custom.updated": "Actualizado",
  "playlists.custom.create": "Crear Lista de Reproducción",
  "playlists.custom.edit": "Editar Lista de Reproducción",
};

export const playlists = {
  ...playlistsList,
  ...playlistModal,
  ...playlistSection,
  ...playlistsPage,
  ...playlistPage,
  ...playlistStatus,
  ...playlistSharingDialog,
  ...playlistScenarioSelectionDialog,
  ...playlistCategoryPage,
  ...playlistReward,
  ...playlistCard,
  ...playlistFilter,
  ...playlistListItem,
  ...playlistScenarioSelector,
  ...playlistScenarioSettings,
  ...customPlaylists,
};
